

import { useState } from "react";
import Config from "../../../Config";

 

import Wall from "../../news/Wall"
import Eat from "./Eat";
import DayPlan from "./DayPlan";
import Calendar from "./Calendar";
 





function NewsView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);  
    }


    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
 

    if(props.mainView.viewSelected == "wall") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "eat") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "day") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "calendar") tab4 = tab4 + " selected";
 

    var subMenu = <div className="submenu">
            <div className={tab1} module="news" view="wall" id="" onClick={props.mainView.quickGo} >{props.userData.dic.mPosts}</div>
            <div className={tab2} module="news" view="eat" id="" onClick={props.mainView.quickGo} >{props.userData.dic.mEat}</div>
            <div className={tab3} module="news" view="day" id="" onClick={props.mainView.quickGo} > {props.userData.dic.mDayP} </div>
            <div className={tab4} module="news" view="calendar" id="" onClick={props.mainView.quickGo} > {props.userData.dic.mCalendar} </div>
    
    </div>
 
 

    if(props.mainView.viewSelected == 'wall' || props.mainView.viewSelected == undefined )
    {
        document.title = props.userData.dic.forParents  + " / " + props.userData.dic.menu_news ; 

        return (
            <div className="econtent ">                           
           
                   {subMenu} 
                  <Wall  userData={props.userData}  mainView={props.mainView}  />
                  
             </div>
        )
    }


    if(props.mainView.viewSelected == 'eat')
        {
            document.title = props.userData.dic.forParents  + " / " + props.userData.dic.mx_eat ; 
    
            return (
                <div className="econtent ">                           
               
                       {subMenu} 
                      <Eat  userData={props.userData}  mainView={props.mainView}  />
                      
                 </div>
            )
        }
 
        

        if(props.mainView.viewSelected == 'day')
            {
                document.title = props.userData.dic.forParents  + " / " + props.userData.dic.mDayP ; 
        
                return (
                    <div className="econtent ">                           
                   
                           {subMenu} 
                          <DayPlan  userData={props.userData}  mainView={props.mainView}  />
                          
                     </div>
                )
            }
     
            
           if(props.mainView.viewSelected == 'calendar')
            {
                document.title = props.userData.dic.forParents  + " / " + props.userData.dic.mDayP ; 
        
                return (
                    <div className="econtent ">                           
                   
                           {subMenu} 
                          <Calendar  userData={props.userData}  mainView={props.mainView}  />
                          
                     </div>
                )
            }  
         
 
                
                

    return (
        <div className="econtent ">
             {props.mainView.viewSelected}
        </div>
    );
}

export default NewsView ;